.editAndStartOverActions {
  display: flex;
  gap: 16px;
}

@media (width <= 768px) {
  .editAndStartOverActions {
    gap: 12px;
  }
}
